exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creditsafe-collaboration {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.creditsafe-collaboration-wrapper {\n  height: 100%;\n}\n\n.creditsafe-collaboration-wrapper .navigation-content-wrap {\n  display: flex;\n}\n\n@media only screen and (min-width: 768px) {\n  .creditsafe-collaboration-block>svg {\n    width: 35rem;\n    height: 7rem;\n    margin-left: auto;\n    margin-right: 25rem;\n  }\n}\n\n@media only screen and (min-width: 1366px) {\n  .creditsafe-collaboration-block>svg {\n    width: 35rem;\n    height: 7rem;\n    margin-left: auto;\n    margin-right: 44rem;\n  }\n}\n\n", ""]);

// exports
